import { render, staticRenderFns } from "./LivePlayers-Single.vue?vue&type=template&id=063d29d2&scoped=true"
import script from "./LivePlayers-Single.js?vue&type=script&lang=js&external"
export * from "./LivePlayers-Single.js?vue&type=script&lang=js&external"
import style0 from "./LivePlayers-Single.vue?vue&type=style&index=0&id=063d29d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d29d2",
  null
  
)

export default component.exports